import axios from 'axios';

import config from '../config';

const Axios = axios.create({
  baseURL: config.apiUrl.concat('api/configuration/'),
  headers: {
    Authorization: `Bearer ${localStorage.getItem('SHERPA_AUTH_JWT_ID')}`
  }
});

export default Axios;
